import {Component, inject, input} from '@angular/core';
import {MemoryService} from '../../../core/services/memory.service';

@Component({
  selector: 'app-logo',
  imports: [],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent {
  memoryService = inject(MemoryService);

  /**
   * The location's logo, for pages outside the StartupComponent shell that loads it into
   * MemoryService. Takes precedence over the remembered location when set.
   */
  imageUrl = input<string | null | undefined>(undefined);

  get logoUrl(): string | undefined {
    return this.imageUrl() || this.memoryService.locationDetailDto?.appearanceSettings?.imageUrl || undefined;
  }
}
